import React, { createContext, useState, ReactNode } from 'react';

type acceptTermsContextType = {
  accepted: string | undefined;
  setAccepted: (accepted: string | undefined) => void;
};

export const AcceptTermsContext = createContext<acceptTermsContextType | undefined>(undefined);

export const AcceptTermsContextProvider = ({ children }: { children: ReactNode }) => {
  const [accepted, setAccepted] = useState<string | undefined>(undefined);

  return (
    <AcceptTermsContext.Provider value={{ accepted, setAccepted }}>
      {children}
    </AcceptTermsContext.Provider>
  );
};
